import { useState } from "react";
import Lottie from "react-lottie-player";
import loadingLoop from "../icons-and-animations/EazyRobo/Loading.json";
import startLoad from "../icons-and-animations/EazyRobo/StartAndLoading.json";

type EazyLoaderProps = {
  size: number;
  isLoop: boolean;
  customAnimation?: object;
};

export const EazyLoader = ({
  size,
  isLoop,
  customAnimation,
}: EazyLoaderProps) => {
  const [animation, setAnimation]: [any, any] = useState(
    customAnimation || startLoad
  );
  const [loop, setLoop] = useState(!!customAnimation);

  return (
    <Lottie
      onComplete={() => {
        if (!customAnimation && loadingLoop) {
          setAnimation(loadingLoop);
          setLoop(isLoop);
        }
      }}
      loop={customAnimation ? isLoop : loop}
      play={true}
      animationData={animation}
      style={{
        height: size + 100,
        width: size + 100,
      }}
    />
  );
};
